import { app } from '../../../../app';

app.directive('pane', pane);

/** @ngInject */
function pane() {
        return {
            require: '^hardTokenTabs',
            restrict: 'E',
            transclude: true,
            scope: { title: '@' },
            link: function(scope, element, attrs, tabsController) {
                tabsController.addPane(scope);
            },
            template:`
            <div class="tab-pane animated" 
                 ng-class="{active: selected,fadeIn: selected}" 
                 ng-transclude>
            </div>`,
            replace: true
        };
    }


// WEBPACK FOOTER //
// ./src/portal/states/public/login-web-saml/hard-token-login/pane.directive.js